import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'


createApp(App).mount('#coverage-checker')
document.querySelectorAll('.coverage-checker')
    .forEach(el => createApp(App).mount(el))
